<template>
  <v-app>
    <!-- <core-filter /> -->


    <core-view />
  </v-app>
</template>

<style lang="scss">
@import '@/styles/index.scss';

/* Remove in 1.2 */
.v-datatable thead th.column.sortable i {
  vertical-align: unset;
}
.container.grid-list-xl .layout:not(:only-child) {
    margin: auto 4px;
}
</style>
<script>
export default {
}
</script>
